export default __webpack_public_path__ + "static/media/setup.f958e9cc.svg";